module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-content-lincoln.e1381af8.jpg";